import script from "./Shipments.vue?vue&type=script&setup=true&lang=js"
export * from "./Shipments.vue?vue&type=script&setup=true&lang=js"

import "./Shipments.vue?vue&type=style&index=0&id=ca8ed864&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca8ed864"]])

export default __exports__